import { useState } from 'react';
import { useIsFetching } from '@tanstack/react-query';
import { productSummaryQueries } from './Inventory/queries/productSummaryQueries';
import { SelectedProductContext } from 'src/products/productsSummary/SelectedProductContext';

export const SelectedProductContextProvider = ({ children }: { children?: React.ReactNode }) => {
  const [selectedProductId, setSelectedProductId] = useState('');

  const isProductTableDataFetching = useIsFetching({
    queryKey: productSummaryQueries.listAll(),
  });

  if (isProductTableDataFetching && selectedProductId !== '') {
    setSelectedProductId('');
  }

  return (
    <SelectedProductContext value={{ selectedProductId, setSelectedProductId }}>
      {children}
    </SelectedProductContext>
  );
};
